import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import List_styles from "./List.styles.js";
const List = (t0)=>{
    const $ = c(8);
    const { listStyleType: t1, pl: t2, children } = t0;
    const listStyleType = void 0 === t1 ? "none" : t1;
    const pl = void 0 === t2 ? 0 : t2;
    let t3;
    if ($[0] !== listStyleType || $[1] !== pl) {
        t3 = {
            listStyleType,
            pl
        };
        $[0] = listStyleType;
        $[1] = pl;
        $[2] = t3;
    } else t3 = $[2];
    const { classes } = List_styles(t3);
    let t4;
    if ($[3] !== classes.list) {
        t4 = classnames(classes.list, "aqa_list");
        $[3] = classes.list;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== children || $[6] !== t4) {
        t5 = /*#__PURE__*/ jsx("ul", {
            className: t4,
            children: children
        });
        $[5] = children;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
export { List };
